import PasteOptionViewState from '../store/schema/PasteOptionViewState';
import { IPoint } from '@fluentui/react/lib/Utilities';
import { action } from 'satcheljs/lib/legacy';

export default action('setPasteOptionPosition')(function setPasteOptionPosition(
    viewState: PasteOptionViewState,
    position: IPoint
) {
    viewState.position = position;
});
